"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterInfoToJSON = exports.FooterInfoFromJSONTyped = exports.FooterInfoFromJSON = exports.instanceOfFooterInfo = void 0;
var runtime_1 = require("../runtime");
var FooterLinkColumn_1 = require("./FooterLinkColumn");
var FooterPaymentMethod_1 = require("./FooterPaymentMethod");
var SocialLink_1 = require("./SocialLink");
/**
 * Check if a given object implements the FooterInfo interface.
 */
function instanceOfFooterInfo(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFooterInfo = instanceOfFooterInfo;
function FooterInfoFromJSON(json) {
    return FooterInfoFromJSONTyped(json, false);
}
exports.FooterInfoFromJSON = FooterInfoFromJSON;
function FooterInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'brandName': !(0, runtime_1.exists)(json, 'brandName') ? undefined : json['brandName'],
        'tagLine': !(0, runtime_1.exists)(json, 'tagLine') ? undefined : json['tagLine'],
        'copyrightText': !(0, runtime_1.exists)(json, 'copyrightText') ? undefined : json['copyrightText'],
        'socialLinks': !(0, runtime_1.exists)(json, 'socialLinks') ? undefined : (json['socialLinks'] === null ? null : json['socialLinks'].map(SocialLink_1.SocialLinkFromJSON)),
        'footerLinkColumns': !(0, runtime_1.exists)(json, 'footerLinkColumns') ? undefined : (json['footerLinkColumns'] === null ? null : json['footerLinkColumns'].map(FooterLinkColumn_1.FooterLinkColumnFromJSON)),
        'paymentMethods': !(0, runtime_1.exists)(json, 'paymentMethods') ? undefined : (0, FooterPaymentMethod_1.FooterPaymentMethodFromJSON)(json['paymentMethods']),
    };
}
exports.FooterInfoFromJSONTyped = FooterInfoFromJSONTyped;
function FooterInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'brandName': value.brandName,
        'tagLine': value.tagLine,
        'copyrightText': value.copyrightText,
        'socialLinks': value.socialLinks === undefined ? undefined : (value.socialLinks === null ? null : value.socialLinks.map(SocialLink_1.SocialLinkToJSON)),
        'footerLinkColumns': value.footerLinkColumns === undefined ? undefined : (value.footerLinkColumns === null ? null : value.footerLinkColumns.map(FooterLinkColumn_1.FooterLinkColumnToJSON)),
        'paymentMethods': (0, FooterPaymentMethod_1.FooterPaymentMethodToJSON)(value.paymentMethods),
    };
}
exports.FooterInfoToJSON = FooterInfoToJSON;
